export default __webpack_public_path__ + "pgnv-assets/c8fe58a4f309755cc2863b4d033dbeb4.svg";